import { range } from "remeda";
import { useTranslation } from "react-i18next";
import {
  OperationRecordRead,
  OperationRecordType,
  OperationRecordTypeI18nKeys,
} from "@/domains/operations";
// components
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";

export const TenantManageOperationsPage = () => {
  const { t } = useTranslation();

  const columns: ColumnsType<OperationRecordRead> = [
    {
      key: "type",
      width: 160,
      title: t("domains.Operations.type"),
      render(_, { type }) {
        return t(OperationRecordTypeI18nKeys[type]);
      },
    },
    {
      width: 164,
      title: t("domains.Operations.source"),
      key: "source",
      render(_, { tenant }) {
        return tenant ? "-" : "系統";
      },
    },
    {
      width: 164,
      title: t("domains.Operations.member"),
      key: "member",
      render(_, { tenant, member }) {
        return tenant ? member.username : "-";
      },
    },
    {
      title: t("domains.Operations.details"),
      dataIndex: "details",
    },
    {
      width: 90,
      align: "right",
      className: "v:top",
      title: t("domains.Operations.createdAt"),
      dataIndex: "created_at",
      sorter: () => 1,
    },
  ];

  const operationRecords = range(1, 30).map<OperationRecordRead>((n) => {
    const type = n % 6;

    const tenant =
      type > OperationRecordType.applyWithdraw
        ? undefined
        : {
            id: n.toString(),
            name: "TACO168",
          };

    return {
      id: n.toString(),
      type,
      tenant,
      member: {
        id: n.toString(),
        username: "ys00t123",
        nickname: "ys00t123",
      },
      details: "",
      created_at: "2023-08-01 12:00:00",
    };
  });

  return (
    <div>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={operationRecords}
      ></Table>
    </div>
  );
};
